import { ElementRef } from '@angular/core';
import { DEFAULT_URL_SHORTENER_MODAL_STATE } from 'NewAngular/features/components/modals/url-shortener-modal/constants';
import { UtilsService } from 'NewAngular/services/core/utils.service';
import { SharingService } from 'SharingApp/ts/services/sharing.service';
import * as i0 from "@angular/core";
import * as i1 from "SharingApp/ts/services/sharing.service";
import * as i2 from "NewAngular/services/core/utils.service";
import * as i3 from "@angular/common";
import * as i4 from "@angular/forms";
import * as i5 from "../modal-base/components/modal-base.component";
import * as i6 from "../modal-base/components/simple-modal-header.component";
const _c0 = ["shortenedUrl"];
const _c1 = () => ({ "border-color": "#00a200" });
const _c2 = () => ({ "border-color": "#cccccc" });
function UrlShortenerModalComponent_span_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 14);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("textContent", ctx_r1.state.error);
} }
/**
 *
 * URL Shortener Modal Component
 *
 * This component allows users to get a shortened URL of the current app state.
 * It automatically copies the shortened URL to the clipboard.
 */
export class UrlShortenerModalComponent {
    constructor(sharingService, utilsService) {
        this.sharingService = sharingService;
        this.utilsService = utilsService;
        this.state = { ...DEFAULT_URL_SHORTENER_MODAL_STATE };
    }
    openModal() {
        this.getShortenedUrl();
        this.state.modalOpen = true;
    }
    closeModal() {
        this.state = { ...DEFAULT_URL_SHORTENER_MODAL_STATE };
    }
    getShortenedUrl() {
        this.sharingService.getShortenedURL(window.location.href).subscribe({
            next: (data) => {
                this.state.shortenedUrl = data.shortened_url;
                this.copyShortenedUrl();
            },
            error: (error) => {
                this.handleError(error);
            },
        });
    }
    selectShortenedUrl() {
        if (this.shortenedUrlInput) {
            this.shortenedUrlInput.nativeElement.select();
        }
    }
    copyShortenedUrl() {
        this.utilsService.copyToClipboard(this.state.shortenedUrl);
        // Wrap this in a setTimeout so that the next change detection cycle triggers before the call to select()
        if (this.shortenedUrlInput) {
            setTimeout(() => {
                this.shortenedUrlInput.nativeElement.select();
            });
        }
        this.state.buttonText = 'Copied';
    }
    handleError(error) {
        switch (error.status) {
            case 400:
                this.state.error = 'The URL you are trying to shorten is invalid.';
                break;
            case 424: // The shortening service had an error
                this.state.error = 'Server error. Please try again later.';
                break;
            default:
                // The backend had another error
                this.state.error = 'There was an issue processing your request. Please try again later.';
                break;
        }
    }
}
UrlShortenerModalComponent.ɵfac = function UrlShortenerModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || UrlShortenerModalComponent)(i0.ɵɵdirectiveInject(i1.SharingService), i0.ɵɵdirectiveInject(i2.UtilsService)); };
UrlShortenerModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: UrlShortenerModalComponent, selectors: [["ycn-url-shortener-modal"]], viewQuery: function UrlShortenerModalComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.shortenedUrlInput = _t.first);
    } }, standalone: false, decls: 15, vars: 9, consts: [["shortenedUrl", ""], [3, "closeModalHandler", "extraModalClasses", "open"], [3, "closeModalHandler", "header"], [1, "modal-body"], [1, "modal-section"], [1, "form-row"], [1, "form-label"], [1, "input-group"], [1, "field-input-group", "input-group"], ["readonly", "", 1, "form-control", 3, "click", "ngModelChange", "ngStyle", "ngModel"], [1, "input-group-btn"], [1, "btn", "btn-secondary", 3, "click", "textContent"], [1, "modal-footer"], ["class", "text-red", 3, "textContent", 4, "ngIf"], [1, "text-red", 3, "textContent"]], template: function UrlShortenerModalComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "ycn-modal-base", 1);
        i0.ɵɵlistener("closeModalHandler", function UrlShortenerModalComponent_Template_ycn_modal_base_closeModalHandler_0_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.closeModal()); });
        i0.ɵɵelementStart(1, "ycn-simple-modal-header", 2);
        i0.ɵɵlistener("closeModalHandler", function UrlShortenerModalComponent_Template_ycn_simple_modal_header_closeModalHandler_1_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.closeModal()); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 3)(3, "div", 4)(4, "div", 5)(5, "div", 6);
        i0.ɵɵtext(6, " Use link below to share with others. ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "div", 7)(8, "div", 8)(9, "input", 9, 0);
        i0.ɵɵlistener("click", function UrlShortenerModalComponent_Template_input_click_9_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.selectShortenedUrl()); });
        i0.ɵɵtwoWayListener("ngModelChange", function UrlShortenerModalComponent_Template_input_ngModelChange_9_listener($event) { i0.ɵɵrestoreView(_r1); i0.ɵɵtwoWayBindingSet(ctx.state.shortenedUrl, $event) || (ctx.state.shortenedUrl = $event); return i0.ɵɵresetView($event); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(11, "span", 10)(12, "a", 11);
        i0.ɵɵlistener("click", function UrlShortenerModalComponent_Template_a_click_12_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.state.shortenedUrl !== "Loading..." && ctx.copyShortenedUrl()); });
        i0.ɵɵelementEnd()()()()()();
        i0.ɵɵelementStart(13, "div", 12);
        i0.ɵɵtemplate(14, UrlShortenerModalComponent_span_14_Template, 1, 1, "span", 13);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵproperty("extraModalClasses", "modal-sm")("open", ctx.state.modalOpen);
        i0.ɵɵadvance();
        i0.ɵɵproperty("header", "Share URL");
        i0.ɵɵadvance(8);
        i0.ɵɵproperty("ngStyle", ctx.state.buttonText === "Copied" ? i0.ɵɵpureFunction0(7, _c1) : i0.ɵɵpureFunction0(8, _c2));
        i0.ɵɵtwoWayProperty("ngModel", ctx.state.shortenedUrl);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("textContent", ctx.state.buttonText);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.state.error);
    } }, dependencies: [i3.NgIf, i3.NgStyle, i4.DefaultValueAccessor, i4.NgControlStatus, i4.NgModel, i5.ModalBaseComponent, i6.SimpleModalHeaderComponent], encapsulation: 2 });
